export const AETHER_FLAG_NAMES = {
  AETHER: 'ff-aether-poc', // [Aether],
};
